import { styled, keyframes } from '@mui/system';
import Table from '@mui/material/Table';

const blink = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
`;

export const PaperWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(3)
}));

export const StyledTable = styled(Table)(() => ({
  minWidth: 700,
  '& th': {
    color: '#667'
  }
}));

export const LoadingTable = styled(Table)(() => ({
  minWidth: 700,
  '& th': {
    padding: '14px 14px 14px 22px',
    color: '#667'
  },
  '& tbody tr': {
    filter: 'blur(5px)',
    height: 54
  },
  '& tbody th, & tbody td': {
    animation: `${blink} 1.5s alternate infinite linear`
  }
}));

export const LogTimeCell = styled('div')(() => ({
  '& p': {
    color: '#000000de',
    fontSize: '0.875rem'
  }
}));

export const ActorCell = styled('div')(() => ({
  '& div': {
    color: '#5eb676',
    fontSize: '0.875rem'
  }
}));
